var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"chart-container",style:(`position: relative; height: 100%`)},[_c('canvas',{ref:"chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }